module.exports = __webpack_public_path__ + "static/media/box-pallet-facing-right.86675df1.svg";